import swal from "sweetalert";
import {
  CREATE_FOLLOW_UP_COMMITE_FAIL,
  CREATE_FOLLOW_UP_COMMITE_REQUEST,
  CREATE_FOLLOW_UP_COMMITE_SUCCESS,
} from "../../ActionType/FollowUpCommiteType/FollowUpCommiteType";
import { getToken } from "../login";
import { api } from "../../Api/api";
import { getVisitAction, updateVisitAction } from "../VisitAction/VisitAction";

export const createFollowUpCommiteAction =
  (
    visit_id,
    patient_id,
    type,
    note,
    doctorId,
    surgeryId,
    typeSurgeryId,
    organLevelId,
    TYPId,
    typeOfHelp,
    assign
  ) =>
  async (dispatch) => {
    
    let doctorList = [];
    doctorId.map((doctor) => {
      doctorList.push(doctor.label);
    });

    let typeOfHelpList = [];
    typeOfHelp.map((typeOfHelp) => {
      typeOfHelpList.push(typeOfHelp.label);
    });

    let surgeryList = [];
    surgeryId.map((doctor) => {
      surgeryList.push(doctor.label);
    });

    let organList = [];
    typeSurgeryId.map((doctor) => {
      organList.push(doctor.label);
    });

    let OrganLevelList = [];
    organLevelId.map((organLevel) => {
      OrganLevelList.push(organLevel.label);
    });

    let TYPList = [];
    TYPId.map((doctor) => {
      TYPList.push(doctor.label);
    });

    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_FOLLOW_UP_COMMITE_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "followUpCommite/create",
        {
          visit_id,
          type,
          note,
          doctor: doctorList,
          disease_type_specialist: surgeryList,
          organ: organList,
          organ_level: OrganLevelList,
          TYP: TYPList,
          type_of_help: typeOfHelpList,
        },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        dispatch(updateVisitAction(visit_id, assign));
        swal({
          title: "Good job!",
          text: "Follow up commite was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch(getVisitAction(patient_id));
        dispatch(getVisitAction(patient_id));
        dispatch({
          type: CREATE_FOLLOW_UP_COMMITE_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: CREATE_FOLLOW_UP_COMMITE_FAIL,
        payload: [],
      });
    }
  };

export const updateFollowUpCommiteAction =
  (
    ids,
    patient_id,
    visit_id,
    type,
    note,
    doctorId,
    surgeryId,
    typeSurgeryId,
    organLevelId,
    TYPId,
    typeOfHelp,
    assign
  ) =>
  async (dispatch) => {
    

    let doctorList = [];
    doctorId.map((doctor) => {
      doctorList.push(doctor.label);
    });
    let typeOfHelpList = [];
    typeOfHelp.map((typeOfHelp) => {
      typeOfHelpList.push(typeOfHelp.label);
    });
    let surgeryList = [];
    surgeryId.map((doctor) => {
      surgeryList.push(doctor.label);
    });

    let organList = [];
    typeSurgeryId.map((doctor) => {
      organList.push(doctor.label);
    });

    let OrganLevelList = [];
    organLevelId.map((doctor) => {
      OrganLevelList.push(doctor.label);
    });

    let TYPList = [];
    TYPId.map((doctor) => {
      TYPList.push(doctor.label);
    });

    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    
    dispatch({
      type: CREATE_FOLLOW_UP_COMMITE_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "followUpCommite/update",
        {
          ids,
          visit_id,
          type,
          note,
          doctor: doctorList,
          disease_type_specialist: surgeryList,
          organ: organList,
          organ_level: OrganLevelList,
          TYP: TYPList,
          type_of_help: typeOfHelpList,
          assign,
        },
        config
      );
      const { status, data } = response;
      
      if (status == 200) {
        dispatch(updateVisitAction(visit_id, assign));
        swal({
          title: "Good job!",
          text: "Follow up commite was Update Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch(getVisitAction(patient_id));
        dispatch(getVisitAction(patient_id));
        dispatch({
          type: CREATE_FOLLOW_UP_COMMITE_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_FOLLOW_UP_COMMITE_FAIL,
        payload: [],
      });
    }
  };
